import { createSelector } from '@reduxjs/toolkit'

export interface FlightDateChangeOrderTraveller {
  employeeId?: string
  firstName: string
  lastName: string
  isPrimaryTraveller: boolean
}

/**
 * The travellers on the flight date change checkout are the booked order item travellers,
 * there are no traveller forms in this flow. Every flight item on the order carries the
 * same traveller set, so the first item is the source.
 */
export const selectFlightDateChangeOrderTravellers = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (existingOrder): Array<FlightDateChangeOrderTraveller> => {
    const orderItemTravellers = existingOrder?.flightItems?.[0]?.orderItemTraveller ?? []

    return orderItemTravellers.map((traveller) => ({
      employeeId: traveller.employeeId,
      firstName: traveller.guestTravellerData?.firstName ?? '',
      lastName: traveller.guestTravellerData?.lastName ?? '',
      isPrimaryTraveller: traveller.isPrimaryTraveller ?? false,
    }))
  },
)
